<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="w-5"
    viewBox="0 0 20.173 26.895"
    aria-hidden="true"
  >
    <g
      id="Raggruppa_8513"
      data-name="Raggruppa 8513"
      transform="translate(-2233.622 -258.033)"
    >
      <path
        id="Tracciato_7916"
        data-name="Tracciato 7916"
        d="M2235.619,284.928a5.848,5.848,0,0,1-1.072-.453,2.108,2.108,0,0,1-.922-1.848q-.006-6.92,0-13.84c0-.455.22-.667.684-.669.507,0,1.014,0,1.56,0,0-.108,0-.2,0-.294,0-.7,0-1.4.008-2.1a7.793,7.793,0,0,1,6.053-7.472,7.856,7.856,0,0,1,9.621,7.761c0,.69,0,1.38,0,2.106h1.429c.653,0,.816.166.816.828q0,6.8,0,13.6a2.225,2.225,0,0,1-1.278,2.148,4.743,4.743,0,0,1-.718.231Zm-.866-15.681c-.005.108-.013.193-.013.278q0,6.487,0,12.973a1.161,1.161,0,0,0,1.308,1.312h15.311a1.165,1.165,0,0,0,1.319-1.327q0-6.473,0-12.947c0-.093-.008-.186-.013-.29Zm13.435-1.144c0-.747,0-1.472,0-2.2a5.471,5.471,0,0,0-.058-.731,4.475,4.475,0,0,0-8.594-.925c-.486,1.257-.225,2.558-.315,3.854Zm-10.086,0c0-.708,0-1.39,0-2.071a5.709,5.709,0,0,1,.5-2.448,5.592,5.592,0,0,1,10.682,1.851c.035.8.024,1.592.034,2.388,0,.092,0,.183,0,.271h1.117c0-.7,0-1.382,0-2.064a6.745,6.745,0,0,0-6.767-6.874,6.367,6.367,0,0,0-4.1,1.436,6.252,6.252,0,0,0-2.459,4.192c-.135,1.079-.081,2.182-.111,3.274,0,.013.019.027.032.046Z"
        fill="#363636"
      />
      <path
        id="Tracciato_7917"
        data-name="Tracciato 7917"
        d="M2355.093,487.266c-.333,0-.665.007-1,0a.6.6,0,0,1-.646-.75c.107-.956.217-1.912.313-2.869a.386.386,0,0,0-.1-.285,2.243,2.243,0,0,1,.948-3.879,2.239,2.239,0,0,1,1.946,3.893.325.325,0,0,0-.089.242c.1.965.21,1.93.318,2.894a.6.6,0,0,1-.642.755h-1.05Zm.507-1.144c-.01-.129-.013-.233-.025-.336-.083-.756-.144-1.515-.26-2.265a.853.853,0,0,1,.451-.978,1.062,1.062,0,0,0,.369-1.346,1.113,1.113,0,0,0-2.128.471,1.086,1.086,0,0,0,.58.962.625.625,0,0,1,.359.643c-.056.512-.118,1.024-.175,1.536-.048.431-.092.863-.139,1.313Z"
        transform="translate(-111.409 -206.817)"
        fill="#363636"
      />
    </g>
  </svg>
</template>
